import { useEffect } from 'react';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';
import { SoundCloudVersionAudioFormProps } from './types';
import { useSoundCloudVersionAudio } from './hooks';
import { SoundCloudVersionAudioForm } from './SoundCloudVersionAudioForm';

export const SoundCloudVersionAudioComponent = (
  props: SoundCloudVersionAudioFormProps
) => {
  const {
    primaryAudio,
    fetchAudioDetailsValidations,
    updateAudioValidations,
  } = props;
  const formProps = useSoundCloudVersionAudio(props);

  useEffect(() => {
    if (!updateAudioValidations && primaryAudio?.audioData.guid) {
      fetchAudioDetailsValidations(primaryAudio.audioData.guid);
    }
  }, [updateAudioValidations, primaryAudio, fetchAudioDetailsValidations]);

  return (
    <ContentContainer type={ContentContainerType.LIST} pb={24}>
      <SoundCloudVersionAudioForm {...formProps} />
    </ContentContainer>
  );
};
